import React, { useEffect } from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { useTraitsActions } from '@atlassian/jira-traits/src/TraitsStore.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { AiRovoCurrentRouteConfigurationProvider } from './AiRovoCurrentRouteConfigurationProvider.tsx';
import { useSubProduct } from '@jira/platform__services-subproduct/src/index.tsx';

/**
 * SPICE-1518 - Rovo for Jira Onboarding Experiment
 *
 * This prefetch determines if users are eligible for onboarding actions, or if they should instead get the default experience after their first two weeks.
 */
const SiteTraitPrefetcher = (): null => {
	useSubProduct();
	const cloudId = useCloudId();
	const { fetchTraits } = useTraitsActions();

	useEffect(() => {
		fetchTraits(['SITE'], { cloudId });
	}, [cloudId, fetchTraits]);

	return null;
};

export const AiRovoCurrentRouteConfigurationProviderWithBoundary = (): React.JSX.Element | null => {
	return (
		<JSErrorBoundary
			fallback="unmount"
			id="rovo-current-route-configuration-provider"
			packageName="ai-rovo-actions-route-provider"
			teamName="reverie"
		>
			{fg('jfind-rovo-for-jira-onboarding-gate') ? <SiteTraitPrefetcher /> : null}
			<UFOSegment name="rovo-current-route-configuration-provider">
				<AiRovoCurrentRouteConfigurationProvider />
			</UFOSegment>
		</JSErrorBoundary>
	);
};
